var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-item text-center"},[_c('div',{staticClass:"rule-or"},[_c('div',{staticClass:"ruled"}),_vm._v(" "),(_vm.dividerCopy)?_c('span',{staticClass:"copy-ruled"},[_vm._v(_vm._s(_vm.dividerCopy))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ruled"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }